import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    es: {
      translation: {
        // NAV
        nav_home: "Home",
        nav_quienes: "Quienes somos",
        nav_contacto: "Contacto",
        nav_experiencias: "Experiencias",
        nav_reseñas: "Reseñas",

        // HOME
        home_titulo: "Las experiencias son únicas y especiales",
        home_subtitulo: "Nuestra Experiencia",
        home_btn_mas: "Descubre más experiencias",
        home_ver_detalles: "Ver detalles",

        // TODAS LAS EXPERIENCIAS
        todas_titulo: "Todas nuestras experiencias",
        todas_subtitulo: "Descubre viajes y aventuras diseñadas para crear recuerdos inolvidables",

        // DETALLE EXPERIENCIA
        detalle_sobre: "Sobre esta experiencia",
        detalle_duracion: "Duración",
        detalle_ubicacion: "Ubicación",
        detalle_categoria: "Categoría",
        detalle_btn_reservar: "Reservar experiencia",
        detalle_btn_reservar_pagar: "Reservar ahora",
        detalle_pago_seguro: "Pago seguro en línea con WeTravel",
        detalle_galeria: "Galería",
        detalle_precios: "Precios",

        // COMENTARIOS
        comentarios_titulo: "Comentarios",
        comentarios_nombre: "Tu nombre",
        comentarios_apellido:"Apellido",
        comentarios_puntuacion:"Puntacion",
        comentarios_imagenes:"Imágenes",
        comentarios_opcional:"Opcional",
        comentarios_texto: "¿Qué te pareció esta experiencia?",
        comentarios_btn: "Enviar comentario",
        comentario_tocar_imagen:"Seleccionar imagen",
        comentarios_vacio: "Sé el primero en comentar esta experiencia.",
        comentario_abrir: "Agregar comentario",
        comentarios_btn_cancelacion: "Cancelar",

        // MODAL RESERVA
        modal_titulo: "Reservar experiencia",
        modal_nombre: "Nombre completo",
        modal_telefono: "Teléfono / WhatsApp",
        modal_comentario: "Comentario adicional",
        modal_btn: "Enviar por WhatsApp",

        // CONTACTO
        contacto_titulo: "Contáctanos",
        contacto_subtitulo: "Estamos aquí para ayudarte a planificar tu próxima aventura en Costa Rica",
        contacto_form_titulo: "Envíanos un mensaje",
        contacto_nombre: "Nombre",
        contacto_apellido: "Apellido",
        contacto_email: "Email",
        contacto_telefono: "Teléfono",
        contacto_mensaje: "Mensaje",
        contacto_placeholder_mensaje: "Cuéntanos sobre tu viaje ideal...",
        contacto_btn: "Enviar mensaje",
        contacto_enviando: "Enviando...",
        contacto_info_titulo: "Información de contacto",
        contacto_mapa: "Encuéntranos",

        // MISION Y VISION
        mision_texto: "Ser uno de los mas prestigiosos tour operador nacional, ofreciendo la mejor calidad de servicio, y asi caracterizarnos por ser una organizacion comprometida con la calidad, y con los mejores tour a mas bajos costos.",
        vision_texto: "Difundir nuestra filosofia y liderazgo como la empresa lider en el mercado turistico Nautico y terrestre de todo el pacifico, mediante un modelo de gestion orientado a la creacion permanente de paquetes para clientes, y nuestros socios comerciales.",

      // ABOUT 
        historia_de_pacific: "Pacific Tour CR es una agencia de turismo familiar en el sector de Pacifico Guanacasteco. Nace en el año 2012, en la zona de Puntarenas, por idea de dos amigos y al pasar el tiempo se unen para asi crear la agencia.",
        motivos: "Por motivos de calidad de vida se desplaza a la zona de Guanacaste, donde nos situamos en el distrito de Carrillo, Playa Hermosa.",
        nuestra_filosofia: " Nuestra filosofia empresarial es dar el mejor servicio para los clientes a un costo accesible y con calidad internacional.",
        extra_de_about: "Desde",


        // QUIENES SOMOS
        quienes_historia: "Nuestra Historia",
        quienes_mision_vision: "Misión y Visión",
        quienes_mision: "Misión",
        quienes_vision: "Visión",
        quienes_valores: "Valores Corporativos",


        valores_liderazgo: "Liderazgo",
        valores_liderazgo_desc: "Practicamos el liderazgo basado en la confianza, reconocemos el valor de cada persona y lo que esta puede generar, estimulamos la participacion, intercambio de ideas y puntos de vista. Nuestros lideres estimulan un ambiente de trabajo en el cual la dignidad de la gente, la alegria en el trabajo y las emociones sean tomadas en cuenta.",
        valores_integridad: "Integridad",
        valores_integridad_desc: "Tenemos el compromiso de hacer las cosas bien desde el principio, al ser sinceros con nuestros clientes y transparentes en el manejo de nuestras operaciones.",
        valores_dinamismo: "Dinamismo",
        valores_dinamismo_desc: "Siendo proactivos y actuando con flexibilidad, nos anticipamos y nos adaptamos a los cambios. Estimulamos y apoyamos el trabajo en equipo, abordamos los trabajos y retos como unidades sinergicas basandonos en una vision compartida.",
        valores_fortaleza: "Fortaleza",
        valores_fortaleza_desc: "El equilibrio entre la prudente toma de decisiones y la osadia de la innovacion son nuestra verdadera propuesta de Tours sostenibles con el medio ambiente y la economia.",

        // FOOTER
        footer_horario: "Horario de Atención",
        footer_lunes_viernes: "Lunes - Viernes",
        footer_sabado: "Sábado",
        footer_domingo: "Domingo",
        footer_disponible: "Disponible 7 días a la semana",
        footer_siguenos: "Síguenos",
        footer_experiencias: "Experiencias Populares",
        footer_derechos: "© 2026 Pacific Tour CR · Todos los derechos reservados",
        footer_terminos: "Los mejores viajes",
        footer_privacidad: "Mejores experiencia",

        carrusel_titulo1: "Nuestra Experiencia",
        carrusel_sub1: "Vive las mejores aventuras en Costa Rica",
        carrusel_titulo2: "Naturaleza Inolvidable",
        carrusel_sub2: "Conéctate con paisajes únicos y auténticos",
        carrusel_titulo3: "Viaja con Nosotros",
        carrusel_sub3: "Únete a las mejores experiencias de Costa Rica",


        
      }
    },
    en: {
      translation: {
        // NAV
        nav_home: "Home",
        nav_quienes: "About Us",
        nav_contacto: "Contact",
        nav_experiencias: "Experiences",
        nav_reseñas: "Reviews",

        // HOME
        home_titulo: "Experiences are unique and special",
        home_subtitulo: "Our Experiences",
        home_btn_mas: "Discover more experiences",
        home_ver_detalles: "View details",

        // TODAS LAS EXPERIENCIAS
        todas_titulo: "All our experiences",
        todas_subtitulo: "Discover trips and adventures designed to create unforgettable memories",

        // DETALLE EXPERIENCIA
        detalle_sobre: "About this experience",
        detalle_duracion: "Duration",
        detalle_ubicacion: "Location",
        detalle_categoria: "Category",
        detalle_btn_reservar: "Book experience",
        detalle_btn_reservar_pagar: "Book now",
        detalle_pago_seguro: "Secure online payment with WeTravel",
        detalle_galeria: "Gallery",
        detalle_precios: "Prices",

        // COMENTARIOS
        comentarios_titulo: "Comments",
        comentarios_nombre: "Your name",
        comentarios_apellido:"Last name",
        comentarios_puntuacion:"Punctuation",
        comentarios_imagenes:"images",
        comentarios_opcional:"Optional",
        comentarios_texto: "What did you think of this experience?",
        comentarios_btn: "Send comment",
        comentario_tocar_imagen:"select image",
        comentarios_vacio: "Be the first to comment on this experience.",
        comentario_abrir: "Add comment",
        comentarios_btn_cancelacion: "Cancel",
      

        // MODAL RESERVA
        modal_titulo: "Book experience",
        modal_nombre: "Full name",
        modal_telefono: "Phone / WhatsApp",
        modal_comentario: "Additional comment",
        modal_btn: "Send via WhatsApp",

        // CONTACTO
        contacto_titulo: "Contact Us",
        contacto_subtitulo: "We're here to help you plan your next adventure in Costa Rica",
        contacto_form_titulo: "Send us a message",
        contacto_nombre: "First name",
        contacto_apellido: "Last name",
        contacto_email: "Email",
        contacto_telefono: "Phone",
        contacto_mensaje: "Message",
        contacto_placeholder_mensaje: "Tell us about your ideal trip...",
        contacto_btn: "Send message",
        contacto_enviando: "Sending...",
        contacto_info_titulo: "Contact information",
        contacto_mapa: "Find us",

      // MISSION Y VISION
       mision_texto: "To be one of the most prestigious national tour operators, offering the best quality of service, and thus characterizing ourselves as an organization committed to quality, with the best tours at the lowest costs.",
       vision_texto: "To spread our philosophy and leadership as the leading company in the nautical and land tourism market throughout the Pacific, through a management model oriented towards the permanent creation of packages for clients and our commercial partners.",

        // QUIENES SOMOS
        quienes_historia: "Our Story",
        quienes_mision_vision: "Mission & Vision",
        quienes_mision: "Mission",
        quienes_vision: "Vision",
        quienes_valores: "Corporate Values",

        

        valores_liderazgo: "Leadership",
        valores_liderazgo_desc: "We practice trust-based leadership, recognizing the value of each person and what they can contribute. We encourage participation, exchange of ideas and points of view. Our leaders foster a work environment where people's dignity, joy at work and emotions are taken into account.",
        valores_integridad: "Integrity",
        valores_integridad_desc: "We are committed to doing things right from the start, being honest with our clients and transparent in the management of our operations.",
        valores_dinamismo: "Dynamism",
        valores_dinamismo_desc: "Being proactive and acting with flexibility, we anticipate and adapt to changes. We encourage and support teamwork, approaching tasks and challenges as synergistic units based on a shared vision.",
        valores_fortaleza: "Strength",
        valores_fortaleza_desc: "The balance between prudent decision-making and the boldness of innovation is our true proposal for sustainable tours with the environment and the economy.",

        // ABOUT 
        historia_de_pacific: "Pacific Tour CR is a family-run tourism agency in the Guanacaste Pacific region. It was founded in 2012 in Puntarenas by two friends who later joined forces to create the agency.",
        motivos: "For quality of life reasons, we moved to the Guanacaste area, where we are located in the Carrillo district, Playa Hermosa.",
        nuestra_filosofia: " Our business philosophy is to provide the best service to customers at an affordable cost and with international quality.",
        extra_de_about: "From",


        // FOOTER
        footer_horario: "Business Hours",
        footer_lunes_viernes: "Monday - Friday",
        footer_sabado: "Saturday",
        footer_domingo: "Sunday",
        footer_disponible: "Available 7 days a week",
        footer_siguenos: "Follow Us",
        footer_experiencias: "Popular Experiences",
        footer_derechos: "© 2026 Pacific Tour CR · All rights reserved",
        footer_terminos: "The best trips",
        footer_privacidad: "Best experiencesaw",


        carrusel_titulo1: "Our Experience",
        carrusel_sub1: "Live the best adventures in Costa Rica",
        carrusel_titulo2: "Unforgettable Nature",
        carrusel_sub2: "Connect with unique and authentic landscapes",
        carrusel_titulo3: "Travel with Us",
        carrusel_sub3: "Join the best experiences in Costa Rica",


      }
    }
  },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false }
});

export default i18n;